import React, { Component } from "react";
import { Form, Button, Message } from "semantic-ui-react";

import { connect } from "react-redux";

import {
  submitReimbursement,
  saveReimbursement,
  reimbursementLoaded
} from "../../actions/unauthenticated/reimbursement";

class ReimbursementEditForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      description: props.description,
      amount: props.amount || "",
      submitting: false,
      confirming: false,
      error: false
    };
  }

  validateForm() {
    return (
      this.state.description.length > 0 &&
      this.state.amount.length > 0 &&
      +this.state.amount >= 0
    );
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value,
      error: false
    });
  };

  handleSubmit = event => {
    event.preventDefault();
    if (!this.state.confirming) {
      this.setState({
        confirming: true,
        amount: (+this.state.amount).toFixed(2)
      });
      return;
    }
    this.setState({
      submitting: true
    });
    this.props
      .submit({
        description: this.state.description,
        amount: this.state.amount
      })
      .then(reimbursement => {
        this.props.reimbursementLoaded(reimbursement);
      })
      .catch(() => {
        this.setState({
          error: true,
          submitting: false,
          confirming: false
        });
      });
  };

  handleCancel = event => {
    event.preventDefault();
    this.setState({
      confirming: false
    });
  };

  handleSave = event => {
    event.preventDefault();
    this.setState({
      submitting: true,
      amount: (+this.state.amount).toFixed(2)
    });
    this.props
      .save({
        description: this.state.description,
        amount: (+this.state.amount).toFixed(2)
      })
      .then(reimbursement => {
        this.props.reimbursementLoaded(reimbursement);
      })
      .catch(() => {
        this.setState({
          error: true
        });
      })
      .finally(() => {
        this.setState({
          submitting: false
        });
      });
  };

  renderForm = () => {
    return (
      <div>
        <Form.Group style={{ marginBottom: "1em" }}>
          <Form.Input
            width={16}
            icon="comment"
            iconPosition="left"
            label="Description"
            required
            placeholder="Coffee with a client, etc."
            value={this.state.description}
            onChange={this.handleChange}
            error={!!this.state.error}
            id="description"
          />
        </Form.Group>
        <Form.Group style={{ marginBottom: "1em" }}>
          <Form.Input
            width={16}
            icon="dollar sign"
            iconPosition="left"
            label="Amount"
            placeholder="12.34"
            required
            value={this.state.amount}
            onChange={this.handleChange}
            error={!!this.state.error}
            type="number"
            min={0}
            id="amount"
          />
        </Form.Group>
        <div style={{ textAlign: "right" }}>
          <Button
            disabled={!this.validateForm() || this.state.submitting}
            onClick={this.handleSave}
          >
            Save
          </Button>
          <Button
            primary
            disabled={!this.validateForm() || this.state.submitting}
            onClick={this.handleSubmit}
          >
            Submit
          </Button>
        </div>
      </div>
    );
  };

  renderConfirm = () => {
    return (
      <div>
        <Form.Group style={{ marginBottom: "1em" }}>
          <Form.Field width={16}>
            <label>Description</label>
            <p style={{ fontSize: "2em" }}>{this.state.description}</p>
          </Form.Field>
        </Form.Group>
        <Form.Group style={{ marginBottom: "1em" }}>
          <Form.Field width={16}>
            <label>Amount</label>
            <p style={{ fontSize: "2em" }}>
              ${(+this.state.amount).toFixed(2)}
            </p>
          </Form.Field>
        </Form.Group>
        <Message warning>
          Once submitted, this information cannot be changed.
        </Message>
        <div style={{ textAlign: "right" }}>
          <Button basic negative onClick={this.handleCancel}>
            Go back
          </Button>
          <Button
            primary
            positive
            disabled={!this.validateForm() || this.state.submitting}
            onClick={this.handleSubmit}
          >
            Confirm
          </Button>
        </div>
      </div>
    );
  };

  render() {
    return (
      <Form
        loading={this.state.submitting}
        style={{ padding: "0 10px" }}
        warning={this.state.confirming}
      >
        {this.state.confirming ? this.renderConfirm() : this.renderForm()}
      </Form>
    );
  }
}

const mapStateToProps = state => ({
  description: state.unauthenticated.reimbursement.description,
  amount: state.unauthenticated.reimbursement.amount,
  save: saveReimbursement(
    state.unauthenticated.reimbursement.uuid,
    state.unauthenticated.reimbursement.modify_key
  ),
  submit: submitReimbursement(
    state.unauthenticated.reimbursement.uuid,
    state.unauthenticated.reimbursement.modify_key
  )
});

const mapDispatchToProps = dispatch => ({
  reimbursementLoaded: reimbursement =>
    dispatch(reimbursementLoaded(reimbursement))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReimbursementEditForm);



// WEBPACK FOOTER //
// ./frontend/src/components/forms/ReimbursementEditForm.js